import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Suspense, lazy } from "react";
import PrivateRoute from "./components/private-route";

const AppFrame = lazy(() => import("./components/app-frame"));
const PlaygroundPage = lazy(() => import("./pages/playground"));
const SessionsPage = lazy(() => import("./pages/sessions"));
const NotFoundPage = lazy(() => import("./pages/not-found"));
const LoginPage = lazy(() => import("./pages/login"));
const TestUIPage = lazy(() => import("./pages/test-ui"));
const TestUIChartPage = lazy(() => import("./pages/test-ui-chart"));
const TestUIStreamPage = lazy(() => import("./pages/test-ui-stream"));
const TestJSONLPreviewPage = lazy(() => import("./pages/test-jsonl-preview"));
const XbrlViewerPage = lazy(() => import("./pages/xbrl-viewer"));

const TestRunsCasesPage = lazy(
  () => import("./pages/admin/test-runs/index"),
);
const TestRunsHistoryPage = lazy(
  () => import("./pages/admin/test-runs/runs"),
);
const TestRunDetailPage = lazy(
  () => import("./pages/admin/test-runs/run-detail"),
);
const AdminMonitoringPage = lazy(
  () => import("./pages/admin/monitoring/index"),
);

/**
 * ProtectedRoutes コンポーネントで、認証が必要なルートを一括して包める仕組みをあらかじめ用意
 */
const ProtectedRoutes = () => {
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  );
};

export default function MainApp() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 認証不要なルート */}
        <Route
          path="/login"
          element={
            <Suspense>
              <LoginPage />
            </Suspense>
          }
        />
        <Route
          path="/test-ui"
          element={
            <Suspense>
              <TestUIPage />
            </Suspense>
          }
        />
        <Route
          path="/test-ui-chart"
          element={
            <Suspense>
              <TestUIChartPage />
            </Suspense>
          }
        />
        <Route
          path="/test-ui-stream"
          element={
            <Suspense>
              <TestUIStreamPage />
            </Suspense>
          }
        />
        <Route
          path="/test-jsonl-preview"
          element={
            <Suspense>
              <TestJSONLPreviewPage />
            </Suspense>
          }
        />
        <Route
          path="/xbrl-viewer"
          element={
            <Suspense>
              <XbrlViewerPage />
            </Suspense>
          }
        />
        {/* AppFrame配下に認証が必要なルートを包括 */}
        <Route
          path="/"
          element={
            <Suspense>
              <AppFrame />
            </Suspense>
          }
        >
          <Route element={<ProtectedRoutes />}>
            <Route
              index
              path=""
              element={
                <Suspense>
                  <PlaygroundPage />
                </Suspense>
              }
            />
            <Route
              path="chat/:sessionId"
              element={
                <Suspense>
                  <PlaygroundPage />
                </Suspense>
              }
            />
            <Route
              path="sessions"
              element={
                <Suspense>
                  <SessionsPage />
                </Suspense>
              }
            />
            <Route
              path="admin/test-runs"
              element={
                <Suspense>
                  <TestRunsCasesPage />
                </Suspense>
              }
            />
            <Route
              path="admin/test-runs/runs"
              element={
                <Suspense>
                  <TestRunsHistoryPage />
                </Suspense>
              }
            />
            <Route
              path="admin/test-runs/:runId"
              element={
                <Suspense>
                  <TestRunDetailPage />
                </Suspense>
              }
            />
            <Route
              path="admin/monitoring"
              element={
                <Suspense>
                  <AdminMonitoringPage />
                </Suspense>
              }
            />
          </Route>
          {/* 公開されたルートまたはNot Found対応 */}
          <Route
            path="*"
            element={
              <Suspense>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
